import { Table } from "../../../../_helpers/Table";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { getDayModels } from "../../../../_api/DayModel";
import { getHourTypes } from "../../../../_api/HourType";
import { getWorkShifts } from "../../../../_api/WorkShift";
import { Button } from "../../../../_helpers/components/Button";
import PlanningHourLimitRulesEditor from "./PlanningHourLimitRulesEditor";

const TimeManagementTab = () => {
    const navigate = useNavigate();
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["HOURS"]["features"];

    const [dayModel, setDayModel] = useState([]);
    const [WorkShift, setWorkShift] = useState([]);
    const [hoursType, setHoursType] = useState([]);

    const [hourTypesRaw, setHourTypesRaw] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const loadHoursTypes = async () => {
        await getHourTypes().then((resp) => {
            const raw = resp.data;
            setHourTypesRaw(Array.isArray(raw) ? raw : []);
            const res = raw.map((res) => {
                return { row: [res.name, res.abbreviation], data: res };
            });
            setHoursType(res);
        });
    };
    const rowClickHoursTypes = (value) => {
        navigate(`/company/hours/${value.id}`);
    };

    const loadWorkShifts = async () => {
        await getWorkShifts().then((resp) => {
            const res = resp.data.map((res) => {
                return { row: [res.name], data: res };
            });
            setWorkShift(res);
        });
    };
    const rowClickWorkShifts = (value) => {
        navigate(`/company/workshift/${value.id}`);
    };

    const loadDayModels = async () => {
        await getDayModels().then((resp) => {
            const res = resp.data.map((res) => {
                return { row: [res.name], data: res };
            });
            setDayModel(res);
        });
    };

    const loadValues = async () => {
        setIsLoading(true);
        await loadDayModels();
        await loadHoursTypes();
        await loadWorkShifts();
        setIsLoading(false);
    };

    const rowClick = (value) => {
        navigate(`/company/daymodel/${value.id}`);
    };

    useEffect(() => {
        loadValues();
    }, []);

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">
                            Gestion des horaires
                        </h1>
                        <p className="mt-2 text-sm text-gray-600">
                            Gérez les types d'heures, modèles de journée et cycles de travail
                        </p>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {isLoading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="text-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary mx-auto mb-4"></div>
                            <p className="text-gray-600 font-medium">Chargement des données...</p>
                        </div>
                    </div>
                ) : (
                    <>
                    <div className="flex flex-wrap gap-4 justify-center">
                        {/* Types d'heures */}
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-w-80 grow">
                            <div className="p-6 border-b border-gray-200">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className="flex items-center justify-center w-10 h-10 bg-linear-to-br from-blue-500 to-blue-600 rounded-lg">
                                            <svg
                                                className="w-6 h-6 text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                        </div>
                                        <h2 className="text-xl font-bold text-gray-900">
                                            Types d'heures
                                        </h2>
                                    </div>
                                    {features_right['add_hour_type'] && (
                                        <Button
                                            type="empty"
                                            action={() => navigate("/company/hours/create")}
                                            name="+"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="p-6">
                                <Table 
                                    headers={["Nom", "Abréviation"]}
                                    rows={hoursType} 
                                    onClick={rowClickHoursTypes} 
                                    hideTitle={true} 
                                />
                            </div>
                        </div>

                        {/* Modèles de journée */}
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-w-80 grow">
                            <div className="p-6 border-b border-gray-200">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className="flex items-center justify-center w-10 h-10 bg-linear-to-br from-green-500 to-green-600 rounded-lg">
                                            <svg
                                                className="w-6 h-6 text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                />
                                            </svg>
                                        </div>
                                        <h2 className="text-xl font-bold text-gray-900">
                                            Modèles de journée
                                        </h2>
                                    </div>
                                    {features_right['add_day_model'] && (
                                        <Button
                                            type="empty"
                                            action={() => navigate("/company/daymodel/create")}
                                            name="+"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="p-6">
                                <Table 
                                    headers={["Nom"]}
                                    rows={dayModel} 
                                    onClick={rowClick} 
                                    hideTitle={true} 
                                />
                            </div>
                        </div>

                        {/* Cycles de travail */}
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-w-80 grow">
                            <div className="p-6 border-b border-gray-200">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className="flex items-center justify-center w-10 h-10 bg-linear-to-br from-purple-500 to-purple-600 rounded-lg">
                                            <svg
                                                className="w-6 h-6 text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                                />
                                            </svg>
                                        </div>
                                        <h2 className="text-xl font-bold text-gray-900">
                                            Cycles de travail
                                        </h2>
                                    </div>
                                    {features_right['add_cycle'] && (
                                        <Button
                                            type="empty"
                                            action={() => navigate("/company/workshift/create")}
                                            name="+"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="p-6">
                                <Table 
                                    headers={["Nom"]}
                                    rows={WorkShift} 
                                    onClick={rowClickWorkShifts} 
                                    hideTitle={true} 
                                />
                            </div>
                        </div>
                    </div>

                    <PlanningHourLimitRulesEditor
                        hourTypes={hourTypesRaw}
                        canManage={features_right["manage_hour_limit_rules"] === true}
                    />
                    </>
                )}
            </div>
        </div>
    );
};

export default TimeManagementTab;
